// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropzone_root__24Gy0 {\n  min-width: 150px;\n  height: 70px;\n  color: grey;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  border: 1px dashed darkgray;\n  border-radius: 15px;\n  padding: 0 5px;\n  background: #eef2f4;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n  .dropzone_root__24Gy0 p {\n    width: 100%;\n    max-width: 800px;\n    overflow: hidden;\n    word-break: break-all;\n    box-sizing: border-box;\n    text-overflow: ellipsis; }\n\n.dropzone_disabled__fstAA {\n  cursor: not-allowed; }\n", ""]);
// Exports
exports.locals = {
	"root": "dropzone_root__24Gy0",
	"disabled": "dropzone_disabled__fstAA"
};
module.exports = exports;
